/*
 * @Author: chenxuelai 2251702447@qq.com
 * @Date: 2023-07-05 09:26:23
 * @LastEditors: chenxuelai 2251702447@qq.com
 * @LastEditTime: 2023-09-27 16:01:40
 * @FilePath: /vue_huaqiang/src/utils/permission_btn.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**

 /**
 * @param {Array} value
 * @returns {Boolean}
 * @example see @/views/permission/directive.vue
 */
export default function checkPermission(value, codes) {
  if (value && value instanceof Array) {
    if (value.length > 0) {
      let hasPermission = false;
      const permissionRoles = value;
      if (codes && codes.length) {
        hasPermission = codes.some((role) => {
          return permissionRoles.includes(role);
        });
      }
      return hasPermission;
    }
  } else {
    return true;
  }
}
